var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},_vm._l((_vm.components),function(component,index){return _c(component.name,{key:index,tag:"Component"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }